module.exports = __webpack_public_path__ + "img/in-screen-side_transparent.9495f143.png";